import { render, staticRenderFns } from "./involvement.vue?vue&type=template&id=06d8c803&"
import script from "./involvement.vue?vue&type=script&lang=js&"
export * from "./involvement.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports